
import { Button } from "@/components/ui/button";
import { ChevronLeft, ArrowRight, Save } from "lucide-react";

interface AssessmentNavigationProps {
  onPrevious: () => void;
  onNext: () => void;
  onSave: () => void;
  isPreviousDisabled: boolean;
  isNextDisabled?: boolean;
  isLastQuestion: boolean;
  isSaving?: boolean;
  isFinishing?: boolean;
}

export function AssessmentNavigation({
  onPrevious,
  onNext,
  onSave,
  isPreviousDisabled,
  isNextDisabled = false,
  isLastQuestion,
  isSaving = false,
  isFinishing = false
}: AssessmentNavigationProps) {
  return (
    <div className="flex flex-col sm:flex-row justify-between items-stretch sm:items-center w-full gap-3 sm:gap-0">
      <Button
        variant="outline"
        onClick={onPrevious}
        disabled={isPreviousDisabled}
        className="min-h-[44px] order-2 sm:order-1"
      >
        <ChevronLeft className="mr-2 h-4 w-4" />
        Back
      </Button>
      
      <div className="flex flex-col sm:flex-row space-y-2 sm:space-y-0 sm:space-x-3 order-1 sm:order-2">
        <Button 
          onClick={onSave}
          disabled={isSaving}
          className="bg-accent text-accent-foreground hover:bg-accent/90 min-h-[44px]"
        >
          <Save className="mr-2 h-4 w-4" />
          {isSaving ? "Saving..." : "Save Progress"}
        </Button>
        
        <Button 
          onClick={onNext}
          disabled={isFinishing || isNextDisabled}
          className="bg-primary hover:bg-primary/90 px-8 min-h-[44px]"
        >
          {isFinishing ? "Saving..." : isLastQuestion ? "Finish" : "Continue"}
          {!isFinishing && <ArrowRight className="ml-2 h-4 w-4" />}
        </Button>
      </div>
    </div>
  );
}
